import React, { createContext, useContext, useState } from 'react';
// Création du contexte
const GalleryContext = createContext();

// Fournisseur du contexte
const GalleryProvider = ({ children }) => {
  const [openGallery, setOpenGallery] = useState({
    showGallery: false,
    galleryId: 'first',
  });

  const toggleGallery = (galleryId) => {
    setOpenGallery((prevState) => ({
      ...prevState,
      galleryId,
      showGallery: !prevState.showGallery,
    }));
  };

  const showMeGallery = (galleryIndex) => {
    console.log('galleryIdgalleryId from showMeGallery CONTEXT', galleryIndex);
    setOpenGallery(() => ({
      galleryId: galleryIndex,
      showGallery: true,
    }));
  };

  const closeGallery = (galleryIndex) => {
    console.log('galleryIdgalleryId from closeGallery CONTEXT', galleryIndex);

    setOpenGallery(() => ({
      galleryId: galleryIndex,
      showGallery: false,
    }));
  };

  return (
    <GalleryContext.Provider
      value={{
        openGallery,
        showMeGallery,
        toggleGallery,
        closeGallery,
        setOpenGallery,
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export default GalleryProvider;

// Hook personnalisé pour utiliser le contexte
/**
 * Custom hook to access the GalleryContext.
 *
 * @returns {Object} The current context value for GalleryContext.
 */
export const useGallery = () => useContext(GalleryContext);
